/* eslint-disable react/no-unknown-property */
const IconLoader = () => (
  <svg
    id="sprite-symbols"
    version="1.1"
    xmlns="http://www.w3.org/2000/symbol"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ display: "none" }}
  >
    <defs id="defs">
      <symbol id="miniintern-logo-PC" width="203" height="34">
        <defs>
          <path id="a" d="M80.592 29.751h80.591V0H0v29.751z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <path
            fill="#ABB1B1"
            d="M84.62 30.58h4.17v-.68h-3.06l1.05-1.06c1.16-1.18 1.86-1.98 1.86-3.14 0-1.2-.73-1.95-2.08-1.95-.76 0-1.44.34-1.86.61l.23.63c.39-.27.93-.55 1.5-.55.95 0 1.38.44 1.38 1.33 0 .96-.64 1.69-1.59 2.68l-1.6 1.66v.47zm12.61-4.1c-1.34-.15-3.13-1.04-3.17-2.27h2.81v-.63h-6.44v.63h2.83c-.04 1.22-1.73 2.14-3.16 2.29l.35.64c1.49-.25 2.85-1.15 3.2-1.97.4.82 1.79 1.7 3.22 1.95l.36-.64zm-3.21 5.22v-3.13h3.58v-.64h-7.89v.64h3.55v3.13h.76zm8.78-3.92v-4.05h-4.14v4.05h4.14zm-.76-.63h-2.62v-2.79h2.62v2.79zm4.37-.94v-.64h-1.33v-2.61h-.76v6.35h.76v-3.1h1.33zm-.99 5.19v-.63h-5.05v-2.06h-.76v2.69h5.81zm3.65-7.68c-1.27 0-1.92 1.24-1.92 2.99 0 1.76.65 2.99 1.92 2.99 1.2 0 1.84-1.07 1.92-2.65h.94v4.23h.74v-8.15h-.74v3.29h-.94c-.06-1.59-.71-2.7-1.92-2.7zm1.17 2.99c0 1.42-.46 2.32-1.17 2.32-.7 0-1.15-.9-1.15-2.32 0-1.41.45-2.32 1.15-2.32.71 0 1.17.91 1.17 2.32zm4.14 4.99v-8.74h-.75v8.74h.75zm11.05-4.27v-4.47h-.76v4.47h.76zm-1.92-.77c-1.08-.39-2.23-1.24-2.23-2.65v-.75h-.77v.78c0 1.4-1.11 2.45-2.24 2.9l.42.58c1.05-.5 1.96-1.35 2.23-2.25.41.92 1.29 1.64 2.16 1.98l.43-.59zm2.25 4.94v-.62h-5.25V30h4.92v-2.09h-5.7v.62h4.94v.9h-4.92v2.17h6.01zm8.08-4.62v-3.53h-5.93v3.53h5.93zm-.76-.63h-4.4v-2.27h4.4v2.27zm-1.83 5.36v-2.98h3.58v-.64h-7.89v.64h3.55v2.98h.76zM145.43 30c0-1.01-1.08-1.65-2.97-1.65-1.91 0-2.98.64-2.98 1.65 0 1.02 1.07 1.66 2.98 1.66 1.89 0 2.97-.64 2.97-1.66zm-2.97-1.01c1.38 0 2.19.37 2.19 1.01 0 .65-.81 1.03-2.19 1.03s-2.19-.38-2.19-1.03c0-.64.81-1.01 2.19-1.01zm.21-1.99h1.93v1.48h.76v-5.52h-.76v1.58h-1.79v.63h1.79v1.2h-1.93V27zm.05-3.36h-4.02v.65h3.16c-.26 1.48-1.74 2.93-3.54 3.43l.38.65c2.31-.81 3.89-2.53 4.02-4.73zm11.3 7.93v-2.74h-5.65v2.74h5.65zm-.76-.63h-4.13v-1.48h4.13v1.48zm.75-2.58v-5.4h-.76v2.82h-1.5v.63h1.5v1.95h.76zm-3.32-4.57v-.64h-2.51v.64h2.51zm1.27 1.24v-.62h-5.1v.62h5.1zm-.46 1.83c0-.9-.89-1.44-2.07-1.44-1.18 0-2.07.54-2.07 1.44 0 .88.9 1.44 2.07 1.44 1.18 0 2.07-.57 2.07-1.44zm-.75 0c0 .53-.62.85-1.32.85-.67 0-1.32-.32-1.32-.85 0-.54.64-.85 1.32-.85.7 0 1.32.31 1.32.85zm12.66.52v-.64h-7.89v.64h7.89zm-.88-2.78c0-.96-1.16-1.52-3.06-1.52-1.88 0-3.04.56-3.04 1.52s1.16 1.51 3.04 1.51c1.9 0 3.06-.55 3.06-1.51zm-3.06-.9c1.39 0 2.29.35 2.29.9 0 .54-.9.88-2.29.88-1.37 0-2.26-.34-2.26-.88 0-.55.89-.9 2.26-.9zm3.24 7.92V31h-5.51v-.88h5.22v-1.96h-6v.61h5.24v.77h-5.22v2.08h6.27zm8.53-3.84v-4.05h-4.14v4.05h4.14zm-.76-.63h-2.62v-2.79h2.62v2.79zm4.37-.94v-.64h-1.33v-2.61h-.76v6.35h.76v-3.1h1.33zm-.99 5.19v-.63h-5.05v-2.06h-.76v2.69h5.81zm8.53-3.46v-.63h-5.19v-2.85h5.11v-.63h-5.87v4.11h5.95zm.95 2.56v-.64h-7.89v.64h7.89zm8.16 1.2v-8.74h-.75v8.74h.75zm-1.73-.44v-8.09h-.74v2.94h-1.55v.64h1.55v4.51h.74zm-1.27-2.32c-.95-.63-1.97-1.9-1.97-3.6v-1.57h-.75v1.59c0 1.71-.88 3.2-1.87 3.83l.47.57c.87-.63 1.59-1.77 1.78-2.77.28.99 1.2 2.03 1.87 2.51l.47-.56zm11.34-3.13c0-1.35-1.25-2.27-3.16-2.27-1.88 0-3.14.92-3.14 2.27s1.26 2.25 3.14 2.25c1.9 0 3.16-.9 3.16-2.25zm-.73 0c0 .98-.97 1.64-2.43 1.64-1.45 0-2.41-.66-2.41-1.64 0-.98.96-1.64 2.41-1.64 1.47 0 2.43.66 2.43 1.64zm1.53 4.78v-.64h-1.98v-1.63l-.76-.02v1.65h-2.44V28.3l-.76.02v1.63h-1.95v.64h7.89z"
          />
          <g transform="translate(1 1)">
            <mask id="b" fill="#fff"></mask>
            <path
              fill="#1A1B1C"
              d="M67.58 29.751c-4.891 0-9.559-2.293-12.46-6.23l2.637-2.03c2.354 3.085 5.947 4.952 9.823 4.952 3.876 0 7.468-1.867 9.863-4.951l2.638 2.03c-2.943 3.936-7.59 6.23-12.501 6.23zm88.185-25.814c3.389-.04 5.419 2.598 5.419 5.926v9.843h-4.039v-9.437c0-1.746-1.116-3.329-2.922-3.247-1.482.06-2.639 1.096-3.37 2.415v10.269h-4.058V4.242h4.059v2.15c1.319-1.562 2.841-2.435 4.911-2.455zm-106.531 0c3.389-.04 5.419 2.598 5.419 5.926v9.843h-4.039v-9.437c0-1.746-1.117-3.329-2.923-3.247-1.481.06-2.638 1.096-3.368 2.415v10.269h-4.059V4.242h4.059v2.15c1.319-1.562 2.841-2.435 4.911-2.455zm40.649 0c3.39-.04 5.419 2.598 5.419 5.926v9.843h-4.039v-9.437c0-1.746-1.116-3.329-2.922-3.247-1.482.06-2.638 1.096-3.369 2.415v10.269h-4.06V4.242h4.06v2.15c1.32-1.562 2.84-2.435 4.91-2.455zM61.979 9.843l2.942-2.354V4.242h-4.383v15.464h4.383v-7.469L61.98 9.843zm61.518.547c-.162-1.988-1.035-3.774-3.125-3.774s-3.085 1.664-3.308 3.774h6.433zm-3.226-6.554c5.256.02 7.224 3.592 7.163 8.422v.588h-10.431c.224 2.841 1.968 4.201 4.627 4.201 2.11 0 3.754-.69 5.46-1.887v3.044c-1.766 1.157-3.45 1.786-6.089 1.786-4.77 0-8.016-2.983-8.016-8.037 0-4.607 2.638-8.137 7.286-8.117zM72.004 9.843l2.943-2.354V4.242h-4.384v15.464h4.384v-7.469l-2.943-2.394zm68.297-5.906c1.4-.101 2.435.365 3.024.913v4.242c-1.4-1.238-3.592-1.482-5.236-.426-.751.487-1.604 1.42-2.212 2.78v8.26h-4.059V4.242h4.059v3.612c.954-2.395 2.76-3.795 4.424-3.917zm-39.195-2.76L105.002 0v4.465h4.709v2.658h-4.709v7.144c-.02 1.522.772 2.374 2.131 2.395 1.096.02 1.786-.244 2.74-.65v3.125c-1.278.589-2.435.853-3.694.853-3.044 0-5.073-1.948-5.073-5.277v-7.59H98.65V4.465h2.455V1.177zM30.239 19.706h4.058V4.242H30.24v15.464zM9.01 3.937c2.171-.04 3.815 1.136 4.728 3.085 1.38-1.847 3.166-3.044 5.419-3.085 3.47-.06 5.48 2.659 5.48 5.865v9.904h-4.06v-9.214c0-1.745-.832-3.47-2.74-3.47-1.36 0-2.719.974-3.53 2.415v10.269h-4.04V10.41c0-1.765-.993-3.39-2.78-3.39-1.48 0-2.719 1.056-3.43 2.416v10.269H0V4.242h4.06v2.15c1.359-1.562 2.9-2.413 4.95-2.454z"
              mask="url(#b)"
            />
          </g>
        </g>
      </symbol>
      <symbol id="miniintern-logo-mobile" width="135" height="24">
        <path
          fill="#1A1B1C"
          fillRule="evenodd"
          d="m46.165 18.974 2.21-1.637a10.497 10.497 0 0 0 8.227 3.994c3.246 0 6.255-1.506 8.26-3.994l2.21 1.637C64.607 22.15 60.715 24 56.602 24c-4.097 0-8.006-1.85-10.437-5.026zM135 7.956v7.94h-3.383V8.284c0-1.408-.934-2.685-2.447-2.62-1.241.05-2.21.884-2.822 1.949v8.283h-3.4V3.422h3.4v1.735c1.105-1.26 2.38-1.965 4.114-1.981C133.3 3.143 135 5.271 135 7.956zm-89.226 0v7.94h-3.382V8.284c0-1.408-.935-2.685-2.448-2.62-1.24.05-2.21.884-2.821 1.949v8.283h-3.4V3.422h3.4v1.735c1.104-1.26 2.38-1.965 4.113-1.981 2.838-.033 4.538 2.095 4.538 4.78zm34.047 0v7.94h-3.383V8.284c0-1.408-.935-2.685-2.448-2.62-1.24.05-2.21.884-2.821 1.949v8.283h-3.4V3.422h3.4v1.735c1.104-1.26 2.379-1.965 4.113-1.981 2.839-.033 4.539 2.095 4.539 4.78zM51.91 7.94l2.464-1.9V3.423h-3.671v12.474h3.671V9.872L51.91 7.94zm51.524.442c-.135-1.604-.866-3.045-2.617-3.045-1.75 0-2.584 1.342-2.77 3.045h5.387zm3.298 1.506v.475h-8.737c.188 2.292 1.649 3.389 3.876 3.389 1.768 0 3.144-.557 4.572-1.523v2.456c-1.479.933-2.89 1.44-5.1 1.44-3.994 0-6.713-2.406-6.713-6.483 0-3.716 2.21-6.564 6.102-6.548 4.402.016 6.051 2.898 6 6.794zM60.307 7.94l2.465-1.9V3.423H59.1v12.474h3.672V9.872L60.307 7.94zm59.735-4.027v3.421c-1.173-.998-3.008-1.195-4.385-.344-.629.393-1.343 1.146-1.853 2.243v6.663h-3.4V3.422h3.4v2.914c.8-1.932 2.312-3.062 3.706-3.16 1.172-.082 2.04.294 2.532.737zM84.682.95 87.944 0v3.601h3.944v2.145h-3.944v5.763c-.017 1.228.646 1.915 1.785 1.932.918.016 1.496-.197 2.295-.524v2.52c-1.071.476-2.04.689-3.094.689-2.55 0-4.25-1.572-4.25-4.257V5.746h-2.056V3.601h2.056V.95zM25.325 15.896h3.4V3.422h-3.4v12.474zM11.507 5.664c1.156-1.49 2.652-2.455 4.538-2.488 2.907-.05 4.59 2.145 4.59 4.731v7.99h-3.4V8.463c0-1.408-.697-2.8-2.294-2.8-1.14 0-2.278.786-2.958 1.949v8.283H8.601V8.4c0-1.425-.833-2.735-2.329-2.735-1.24 0-2.278.852-2.873 1.949v8.283H0V3.422h3.4v1.735c1.138-1.26 2.43-1.948 4.147-1.981 1.818-.033 3.195.917 3.96 2.488z"
        />
      </symbol>
      <symbol id="hamburger-bar" width="28" height="28">
        <g fill="none">
          <path d="M0 0h28v28H0z" />
          <g fill="#000" transform="translate(5 7)">
            <rect width="18" height="2" rx="1" />
            <rect width="18" height="2" y="6" rx="1" />
            <rect width="18" height="2" y="12" rx="1" />
          </g>
        </g>
      </symbol>
      <symbol id="white-arrow" width="118" height="8">
        <path fill="none" stroke="#FFF" d="M0 7h118l-7.652-6" />
      </symbol>
      <symbol id="question-mark-tooltip" width="24" height="24">
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h24v24H0z" />
          <path
            fill="#384040"
            d="M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm.6 12h-1.7v1.7h1.7V15zm-.536-8c-.246 0-.496.023-.752.068a5.807 5.807 0 0 0-.755.188 7.083 7.083 0 0 0-1.357.598l.697 1.511c.388-.191.762-.353 1.125-.485.362-.132.7-.198 1.015-.198.36 0 .628.084.803.253a.853.853 0 0 1 .263.642c0 .169-.018.317-.054.444-.037.128-.096.25-.178.366a2.17 2.17 0 0 1-.321.352 9.9 9.9 0 0 1-.486.404c-.218.173-.405.34-.56.502a2.582 2.582 0 0 0-.38.499c-.098.17-.17.351-.218.54-.048.19-.072.4-.072.632v.506h1.804v-.41c0-.146.013-.272.038-.38a.925.925 0 0 1 .14-.31c.069-.1.163-.207.284-.318.12-.112.277-.243.468-.393.25-.2.47-.391.66-.571a3.17 3.17 0 0 0 .472-.56c.125-.194.22-.404.283-.63a2.83 2.83 0 0 0 .096-.769c0-.391-.07-.74-.209-1.045a2.155 2.155 0 0 0-.598-.78 2.679 2.679 0 0 0-.95-.489A4.388 4.388 0 0 0 12.064 7z"
          />
        </g>
      </symbol>
      <symbol id="blue-arrow" width="28" height="8">
        <path fill="none" stroke="#17a1ff" d="M0 7h28l-7.652-6" />
      </symbol>
      <symbol id="card-label-employment" width="60" height="26">
        <defs>
          <filter
            id="a"
            width="106.9%"
            height="116.7%"
            x="-3.4%"
            y="-4.2%"
            filterUnits="objectBoundingBox"
          >
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
              stdDeviation=".5"
            />
            <feColorMatrix
              in="shadowBlurOuter1"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
            />
          </filter>
          <path id="b" d="M16 0h42v24H16L0 12.013z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(1)">
            {/* <use xlink:href="#b" fill="#000" filter="url(#a)" />
              <use xlink:href="#b" fill="#FE883C" /> */}
          </g>
          <text
            fill="#FFF"
            fontFamily="NotoSansKR-Bold, Noto Sans KR"
            fontSize="12"
            fontWeight="bold"
            transform="translate(1)"
          >
            <tspan x="16.88" y="16">
              채용형
            </tspan>
          </text>
        </g>
      </symbol>
      <symbol id="card-label-education" width="60" height="26">
        <defs>
          <filter
            id="a"
            width="106.9%"
            height="116.7%"
            x="-3.4%"
            y="-4.2%"
            filterUnits="objectBoundingBox"
          >
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
              stdDeviation=".5"
            />
            <feColorMatrix
              in="shadowBlurOuter1"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
            />
          </filter>
          <path id="b" d="M16 0h42v24H16L0 12.013z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(1)">
            {/* <use xlink:href="#b" fill="#000" filter="url(#a)" />
              <use xlink:href="#b" fill="#1BC481" /> */}
          </g>
          <text
            fill="#FFF"
            fontFamily="NotoSansKR-Bold, Noto Sans KR"
            fontSize="12"
            fontWeight="bold"
            transform="translate(1)"
          >
            <tspan x="16.88" y="16">
              교육형
            </tspan>
          </text>
        </g>
      </symbol>
      <symbol id="card-button-heart" width="24" height="24">
        <g fill="none" fillRule="evenodd">
          <rect
            width="24"
            height="24"
            fill="#ABB1B1"
            fillRule="nonzero"
            opacity=".3"
            rx="3"
          />
          <path d="M4 4h16v16H4z" />
          <path d="M4 4h16v16H4z" />
          <path
            stroke="#FFF"
            d="M15 6.5c.882 0 1.68.368 2.251.992.571.623.916 1.496.916 2.508 0 4.039-3.97 6.457-5.882 7.584C9.856 16.472 5.833 14.06 5.833 10c0-1.009.349-1.88.919-2.501A3.034 3.034 0 0 1 9 6.5c1.097 0 2.058.599 2.646 1.187.12.119.24.253.354.401a4.32 4.32 0 0 1 .354-.401C12.942 7.099 13.904 6.5 15 6.5z"
          />
        </g>
      </symbol>
      <symbol id="button-instagram" width="26" height="26">
        <g fill="none" fillRule="evenodd">
          <path fill="#F0F3F3" d="M-1870-151H467v1794h-2337z" />
          <path fill="#FFF" d="M-1159-73H281v255h-1440z" />
          <path
            fill="#384040"
            d="M26 13c0 7.18-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0s13 5.82 13 13"
          />
          <g fill="#FFF">
            <path d="M16.909 8.2a.871.871 0 1 0 0 1.742.871.871 0 0 0 0-1.742m-3.872 7.12a2.347 2.347 0 0 1-2.344-2.344 2.347 2.347 0 0 1 2.344-2.344 2.345 2.345 0 0 1 0 4.688m0-6.002c-2.018 0-3.66 1.64-3.66 3.658s1.642 3.66 3.66 3.66a3.663 3.663 0 0 0 3.659-3.66 3.662 3.662 0 0 0-3.66-3.658" />
            <path d="M10.009 6.945a3.067 3.067 0 0 0-3.064 3.065v5.932a3.068 3.068 0 0 0 3.064 3.065h5.933a3.068 3.068 0 0 0 3.065-3.065V10.01a3.069 3.069 0 0 0-3.065-3.065h-5.933zm5.933 13.46h-5.933a4.468 4.468 0 0 1-4.462-4.463V10.01a4.468 4.468 0 0 1 4.462-4.463h5.933a4.467 4.467 0 0 1 4.462 4.463v5.932c0 2.461-2 4.463-4.462 4.463z" />
          </g>
        </g>
      </symbol>
      <symbol id="close" width="20" height="20" fill="none" viewBox="0 0 10 10">
        <path
          fill="#000"
          d="M.77 10 0 9.23 4.23 5 0 .77.77 0 5 4.23 9.23 0l.77.77L5.77 5 10 9.23l-.77.77L5 5.77.77 10Z"
        />
      </symbol>
    </defs>
  </svg>
);
export default IconLoader;
